import toast from "react-hot-toast";
import { cricketFancyPL, cricketMatchOddsPL } from "../../utils/profitLoss";
import store from "../../redux/store";

export const getOddForEntity = (
  entity,
  odds,
  isBack = true,
  giveSize = false,
  status = false,
  fullObj = false
) => {
  let data = odds?.data?.response?.oddDetailsDTOS?.find(
    (odd) => odd.runnerName?.toLowerCase() === entity?.toLowerCase()
  );
  if (fullObj) {
    return data;
  }
  if (status) {
    return data?.status;
  }
  if (data) {
    if (giveSize) {
      return isBack ? data.backSize1 : data.laySize1;
    }
    return isBack ? data.back1 : data.lay1;
  }
};
export const getCasinoPlExposureByRunner = (data, runnerName, selectionId) => {
  if (!data || !data?.length > 0) return 0;
  let exp = data[0]?.casinoPLExposure?.find(
    (exposure) =>
      runnerName?.toLowerCase() === exposure.selectionName?.toLowerCase()
  )?.exposure;
  return (
    <span
      style={{
        color: exp > 0 ? "green" : "red",
      }}
    >
      {exp}
    </span>
  );
};

export const setBet = (
  runnerName,
  casinoData,
  dispatch,
  type = "back",
  market = false,
  takeSize = false,
  isYesAndNo = false
) => {
  const selectedEventForBet_ = store.getState().gameData.selectedEventForBet;
  let matchData = casinoData?.data?.response;

  let data = matchData?.oddDetailsDTOS?.find(
    (odd) => odd?.runnerName?.toLowerCase() === runnerName?.toLowerCase()
  );
  if (market) {
    data = matchData[market]?.find(
      (odd) => odd?.runnerName?.toLowerCase() === runnerName?.toLowerCase()
    );
  }

  if (!data) {
    toast.error("No data found for this event");
    return;
  }
  const isBack = type?.startsWith("back");

  if (!matchData) return;
  var game = "casino";
  let amount = selectedEventForBet_?.amount
    ? selectedEventForBet_?.amount
    : 100;
  let profit;
  let loss;

  if (takeSize) {
    profit = cricketFancyPL(
      isBack ? data?.backSize1 : data?.laySize1,
      amount,
      type == "back" ? "yes" : "no"
    ).profit;
    loss = (isBack ? data?.backSize1 : data?.laySize1,
    amount,
    type == "back" ? "yes" : "no").loss;
  } else {
    profit = cricketMatchOddsPL(isBack ? data?.back1 : data?.lay1, amount, type)
      .profit;
    loss = cricketMatchOddsPL(isBack ? data?.back1 : data?.lay1, amount, type)
      .loss;
  }

  if (data?.casinoGames == "CARD32EU" || data?.casinoGames == "CARD_32") {
    profit = cricketFancyPL(data?.back1, amount, type).profit;
    loss = cricketFancyPL(data?.back1, amount, type).loss;
  }
  if (isYesAndNo) {
    if (type == "back") {
      profit = data?.back1;
      loss = amount;
    } else {
      profit = amount;
      loss = data?.lay1;
    }
  }
  let selectedEventForBet = {
    marketId: matchData?.marketId,
    type,
    selectedOdd: takeSize
      ? isBack
        ? data?.backSize1
        : data?.laySize1
      : isBack
      ? data?.back1
      : data?.lay1,
    selectedId: data?.selectionId,
    profit: profit,
    loss: loss,
    amount: amount,
    runnerName: data?.runnerName,
    isYesAndNo: false,
    isBack: isBack,
    takeSize,
    run: isBack ? data?.back1 : data?.lay1,
  };
  selectedEventForBet[type] = data?.back1;
  if (takeSize) {
    selectedEventForBet["size"] =
      type == "back" ? data?.backSize1 : data?.laySize1;
  }
  if (selectedEventForBet?.selectedOdd == 0) {
    return;
  }
  dispatch({
    type: "gameData/setSelectedEventForBet",
    payload: selectedEventForBet,
  });
};
